import { render, staticRenderFns } from "./ScannedDeliveries.vue?vue&type=template&id=31743624&lang=pug"
import script from "./ScannedDeliveries.vue?vue&type=script&lang=js"
export * from "./ScannedDeliveries.vue?vue&type=script&lang=js"
import style0 from "./ScannedDeliveries.vue?vue&type=style&index=0&id=31743624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports